<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">Barınak Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Barınak kartlarını
                                        buradan ekleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Tedarikçi Adı: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.name"
                                            placeholder="Tedarikçi Adı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Telefonu: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.phone"
                                            placeholder="Tedarikçi Telefonu">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">E-Posta: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.email"
                                            placeholder="E-Posta">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Vergi Dairesi: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.tax_office"
                                            placeholder="Vergi Dairesi">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Vergi Numarası: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.tax_number"
                                            placeholder="Vergi Numarası">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Adresi: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="supplier.address"
                                            placeholder="Adresi">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default {
    name: 'CreateShelter',
    data() {
        return {
            supplier: {
                name: "",
                phone: "",
                email: "",
                tax_office: "",
                tax_number: "",
                address: "",
            },
        }
    },
    async mounted() {
        // await this.fetchSpecies();
    },
    methods: {
        async submitForm() {
            try {
                const response = await this.$axios.post('supplier/', this.supplier, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
                this.$router.push({ name: 'Suppliers', params: { page: 1 } });
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>